<section class="cz-terms-of-use-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-7">
        <h3 class="title" [innerHTML]="'$login_footer_terms_label' | translate"></h3>
      </div>
      <div class="col-xs-5 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
            <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <p [innerHTML]="'$login_footer_terms_content' | translate"></p>
    <p>
      <a class="privacy-link" href="/login?openPrivacyPolicy=true" target="_blank" rel="noopener noreferrer">
        {{'$login_footer_privacy_policy_label' | translate}}
      </a>
    </p>
      <div class="row bottom-buttons">
        <div class="col-xs-6">
          <button mat-flat-button color="accent" (click)="downloadPDF()">{{'$lng_eu_download' | translate}}</button>
        </div>
        <div class="col-xs-6 end-xs">
          <button mat-flat-button color="primary" mat-dialog-close  [innerHTML]="'$btn_close' | translate"></button>
        </div>
      </div>
    <div></div>
  </mat-dialog-content>
</section>
